import { render, staticRenderFns } from "./AutoInjectSettings.vue?vue&type=template&id=1bcc6b2c&scoped=true&"
import script from "./AutoInjectSettings.vue?vue&type=script&lang=js&"
export * from "./AutoInjectSettings.vue?vue&type=script&lang=js&"
import style0 from "./AutoInjectSettings.vue?vue&type=style&index=0&id=1bcc6b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc6b2c",
  null
  
)

export default component.exports